import axios from "axios";

export default function changeAccountSecuritySetting(data) {
  return axios.put("/account/security-setting", data);
}
